__webpack_public_path__ = process.env.NODE_ENV === 'development'
		? process.env.VUE_APP_PUBLIC_PATH
		: `${promokit.store('assetsPath')}${process.env.VUE_APP_PUBLIC_PATH}`;

promokit.store('assetsPath', __webpack_public_path__);
